module.exports = __webpack_public_path__ + "assets/media/banner_home.8fd363d8.mp4";